import { render } from "./updateFournisor.vue?vue&type=template&id=32aea1f2&scoped=true"
import script from "./updateFournisor.vue?vue&type=script&lang=js"
export * from "./updateFournisor.vue?vue&type=script&lang=js"

import "./updateFournisor.vue?vue&type=style&index=0&id=32aea1f2&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32aea1f2"]])

export default __exports__